import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
// import { environment } from '../../../environments/environment';
import { timeout } from "rxjs/operators";
import { UserService } from "./user.service";

@Injectable({ providedIn: "root" })
export class HttpInterceptService implements HttpInterceptor {
  constructor(private authService: UserService) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes("veritaslegalplan.com")) {
      return next.handle(request);
    }

    return next
      .handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authService.user?.token}`,
          },
        })
      )
      .pipe(timeout(300000 /* 30 seconds */));
  }
}
